import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "switch"
}
const _hoisted_10 = ["id", "checked", "onChange"]
const _hoisted_11 = ["for"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
          to: "/add-user"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Nouveau Utilisateur ", -1),
            _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
          ])),
          _: 1,
          __: [1]
        }),
        _cache[2] || (_cache[2] = _createElementVNode("button", {
          class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
          type: "button"
        }, [
          _createTextVNode(" Export "),
          _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" })
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control text-black rounded-0",
          placeholder: "Chercher",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users.searchTerm) = $event))
        }, null, 512), [
          [_vModelText, _ctx.users.searchTerm]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_vue_good_table, {
        columns: _ctx.headers,
        rows: _ctx.rows
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Aucune entrées correspondantes trouvées", -1)
            ])),
            _: 1,
            __: [3]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field == 'created_at')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
            : (props.column.field == 'logout_time')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(props.row.logout_time ? _ctx.getDate(props.row.logout_time) : ""), 1))
              : (props.column.field == 'active')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    (_ctx.auth.can('EDIT_USER'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "switch-input",
                            id: 'switch-' + props.row.id,
                            checked: props.row.active,
                            onChange: ($event: any) => (_ctx.toggleAdActive(props.row))
                          }, null, 40, _hoisted_10),
                          _createElementVNode("label", {
                            class: "switch-label",
                            for: 'switch-' + props.row.id
                          }, null, 8, _hoisted_11)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (props.column.field == 'actions')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[6] || (_cache[6] = _createElementVNode("button", {
                          class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-dots" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_14, [
                          (_ctx.auth.can('EDIT_USER'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: _withModifiers(($event: any) => (
                      _ctx.$router.push({
                        name: 'EditUserPage',
                        params: { id: props.row.id },
                      })
                    ), ["prevent"])
                                }, _cache[4] || (_cache[4] = [
                                  _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Modifier ", -1)
                                ]), 8, _hoisted_16)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: _withModifiers(($event: any) => (
                      _ctx.$router.push({
                        name: 'HistoryUserPage',
                        params: { id: props.row.id },
                      })
                    ), ["prevent"])
                            }, _cache[5] || (_cache[5] = [
                              _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Historique ", -1)
                            ]), 8, _hoisted_17)
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.users,
        offset: 9,
        onPaginate: _ctx.fetchData
      }, null, 8, ["pagination", "onPaginate"])
    ])
  ]))
}